"use strict";
/* globals module */
/**
 * @module shoppingCartItemBatchRoute
 * @description Baasic Shopping Cart Item Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Item Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var ShoppingCartItemBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ShoppingCartItemBatchRoute, _super);
    function ShoppingCartItemBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'commerce/carts/items/batch';
        _this.deleteRoute = 'commerce/carts/items/batch';
        _this.createRoute = 'commerce/carts/items/batch';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.update();
     **/
    ShoppingCartItemBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.create();
     **/
    ShoppingCartItemBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.delete();
     **/
    ShoppingCartItemBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    ShoppingCartItemBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ShoppingCartItemBatchRoute);
    return ShoppingCartItemBatchRoute;
}(common_1.BaseRoute));
exports.ShoppingCartItemBatchRoute = ShoppingCartItemBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
